/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './blood-bank-access.reducer';

export const BloodBankAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const bloodBankAccessEntity = useAppSelector(state => state.bloodBankAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="bloodBankAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.bloodBankAccess.detail.title">BloodBankAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.id}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.uhid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.bloodBankAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{bloodBankAccessEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankAccess.comboUser">Combo User</Translate>
          </dt>
          <dd>{bloodBankAccessEntity.comboUser ? bloodBankAccessEntity.comboUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.bloodBankAccess.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{bloodBankAccessEntity.glucoUser ? bloodBankAccessEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/blood-bank-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/blood-bank-access/${bloodBankAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default BloodBankAccessDetail;
